module.exports = __webpack_public_path__ + "img/waves-4.c74f8ccf.jpg";